
const PendingTab = require('app/billing/payment/list/PendingTab');
const ReceivedTab = require('app/billing/payment/list/ReceivedTab');
const CreditAgricoleTab = require('app/billing/payment/list/CreditAgricoleTab');

class ListView {
    defaultOptions() {
        return {
            'activeTab': 'pending',
            'selector': '.view-billing-payment-list',
            'invoice': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }
    
    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'pending':
                let pendingTab = new PendingTab({
                    'invoice': this.settings.invoice,
                    '$container': $tabBody
                });
            break;
            case 'received':
                let receivedTab = new ReceivedTab({
                    'invoice': this.settings.invoice,
                    '$container': $tabBody
                });
            break;
            case 'credit_agricole':
                let creditAgricoleTab = new CreditAgricoleTab({
                    'invoice': this.settings.invoice,
                    '$container': $tabBody
                });
            break;
        }
    }

}

module.exports = ListView;

